import { JQElementHelper } from "../lib/JQElementHelper";
import { InputEventHelper } from "./Helper/InputEventHelper";
import { InputIconHelper } from "./Helper/InputIconHelper";
export class AxInput {
    constructor(selector) {
        this.jqElementHelper = new JQElementHelper();
        this.selector = selector;
    }
    init() {
        this.$parents = $(this.selector);
        this.jqElementHelper.iterateSelector(this.$parents, ($elem) => {
            let $parent = $elem.parent();
            let $icon = $parent.find('i');
            if ($icon.length === 0) {
                $parent.append('<i class="d-none"></i>');
                $icon = $parent.find('i');
            }
            const iconHelper = new InputIconHelper($elem, $icon);
            const inputEventHelper = new InputEventHelper($elem, $parent, $icon);
            $elem.on({
                focus: () => {
                    inputEventHelper.focus();
                },
                keyup: () => {
                    inputEventHelper.keyup();
                },
                blur: () => {
                    inputEventHelper.blur();
                }
            });
            $parent.on({
                mouseenter: () => {
                    iconHelper.drawDeleteIcon();
                },
                mouseleave: () => {
                    iconHelper.drawValidOrResetIcon();
                }
            });
            $icon.on("click", () => {
                inputEventHelper.iconClick();
            });
        });
    }
}
